import { DatasetUploadsPage, type DatasetUploadsPageProps } from "@/components/dataset-uploads/DatasetUploadsPage"
import { transDistSoConfig } from "@/lib/datasetRegistry"

// Thin config module — driven by `transDistSoConfig`. The only page-specific JSX
// is the semicolon/Net Value dropzone detail line, passed as the typed
// `dropzoneDetail` slot. Controller renders "admin/trans_dist_so/Uploads".
export default function AdminTransDistSoUploads(props: Omit<DatasetUploadsPageProps, "config">) {
  return (
    <DatasetUploadsPage
      config={transDistSoConfig}
      dropzoneDetail={
        <p className="mt-1 text-xs text-ink-muted">
          File harus dipisahkan dengan semicolon (<strong>;</strong>) dan mengandung kolom <strong>Net Value</strong>.
        </p>
      }
      {...props}
    />
  )
}
